/*
    delay for autocomplete input field
*/
export const debounceTime = 500;
